import { Select, SelectProps, useTranslation } from "@harea/component";

const StatusSelect = (props: SelectProps) => {
    const t = useTranslation();

    const options = dayOffStatus.map((status) => ({
        ...status,
        label: t(status.label),
    }));

    return <Select {...props} options={options} />;
};

export default StatusSelect;

export const dayOffStatus = [
    { label: "std_new", value: "new" },
    { label: "std_approved", value: "approved" },
    { label: "std_validated", value: "validated" },
    { label: "std_refused", value: "refused" },
];
